angular.module('app').controller('TerritoryCtrl', function($controller, $scope, $mdToast) {
    "ngInject";

    var main = this;


    main.name = 'territory';
    main.defaults = {
        'zip_codes': []
    };

    main.zips = [];

    main.transformZipCodes = () => {
        main.zips = main.item.zip_codes.map((z) => {
            return z.zip;
        });
    }

    $scope.$on('model-loaded', main.transformZipCodes);
    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.save = function() {
        main.item.zip_codes = main.zips.map((z) => {
            return {'zip': z};
        });
        main._save();
    }
});
